<template>
    <canvas id="canvas-poster"></canvas>
</template>
<script>
import { bindAppFn } from '../../utils'
export default {
    name: 'vipCoachV2SavePhoto',
    props: {
        info: {
            type: Object,
            default: () => ({
                coachName: '',
                backgroundPicUrl: '',
                qrCodeUrl: '',
                logoUrl: '',
            })
        },
        subject: {
            type: Number,
            default: 1
        }
    },
    data() {
        return {
            ctx: null,
            canvasWidth: 375,
            canvasHeight: 667,
            base64: '',
            isShare: false
        }
    },
    methods: {
        async init () {
            const canvas = document.getElementById('canvas-poster')
            canvas.width = this.canvasWidth
            canvas.height = this.canvasHeight
            this.ctx = canvas.getContext("2d");
            // 绘制底图
            await this.setPhotoToCanvas(this.info.backgroundPicUrl, 0, 0, this.canvasWidth, this.canvasHeight)
            // 设置头部底色
            this.setRect('#00000080', 0, 0, this.canvasWidth, 40)
            // 设置头部教练信息
            this.setTopText()
            // 绘制二维码
            await this.setPhotoToCanvas(this.info.qrCodeUrl, 104, 440, 166, 166)
            // 设置logo底色
            this.setRect('#fff', 167, 503, 40, 40)
            // 绘制logo
            await this.setPhotoToCanvas(this.info.logoUrl, 169, 505, 36, 36)
            // 设置底部文字
            this.setBottomText()
            this.ctx.save()
            this.base64 = canvas.toDataURL()
        },
        /**
         * 绘制图片到canvas
         * @param {String} imgUrl 图片url
         * @param {number} x x轴
         * @param {number} y y轴
         * @param {number} width 宽度
         * @param {number} height 高度
         */
        setPhotoToCanvas (imgUrl, x, y, width, height) {
            return new Promise((resolve) => {
                const img = document.createElement('img');
                img.setAttribute('crossOrigin', 'anonymous')
                img.width = width
                img.height = height
                img.onload = () => {
                    this.ctx.drawImage(img, x, y, width, height);
                    resolve()
                }
                img.src = imgUrl;
            })
        },
        /**
         * 绘制矩形到canvas
         * @param {String} color 颜色
         * @param {number} x x轴
         * @param {number} y y轴
         * @param {number} width 宽度
         * @param {number} height 高度
         */
        setRect (color, x, y, width, height) {
            this.ctx.fillStyle = color;
            this.ctx.fillRect(x, y, width, height);
        },
        // 设置头部教练信息
        setTopText () {
            this.ctx.font = '16px 微软雅黑';
            this.ctx.fillStyle = '#ffffff'
            this.ctx.textAlign = 'center'
            this.ctx.fillText(`${this.info.coachName}教练向您推荐`, this.canvasWidth/2, 26);
        },
        // 设置底部文字
        setBottomText () {
            this.ctx.font = 'bold 16px 微软雅黑';
            this.ctx.fillStyle = '#ffffff'
            this.ctx.textAlign = 'center'
            this.ctx.fillText('扫码开通VIP高效学', this.canvasWidth/2, 634);
        },
        /**
         * 分享功能
         * @param {'Wechat-Friends'|'Wechat-Moments'} type 发送给好友 或 分享到朋友圈
         * @param {'url'|'imageBase64'} shareContentType 是分享url 还是 图片
         * @param {1|2|3|4} subject 科目一 到 科目四
         * @param {Boolean} isExamFlag 是否允许考场视频
         */
        share(type, shareContentType, subject = 1, isExamFlag = false) {
            const { coachName, backgroundPicUrl, qrCodeUrl, logoUrl, jumpLink } = this.info
            // 获取对应的科目 以及分享内容
            const [subjectName, description] = {
                1: ['科目一', '精选科一题库，掌握一题=练习多题，助您快速通过科目一！'],
                2: ['科目二', '考场难点讲解，教学视频优先学，助您快速通过科目二！'],
                3: ['科目三', isExamFlag ? '考场视频抢先看，教学视频优先学，快人一步了解路线，助您快速通过科目三！' : '教学视频优先学，助您快速通过科目三！ ——无考场视频'],
                4: ['科目四', '精选科四题库，掌握一题=练习多题，助您快速通过科目四！'],
            }[subject]
            // 分享标题
            const content = `${coachName || ''}教练为您推荐了${subjectName}VIP包，赶快查看吧！`

            const params = {
                url: {
                    type,
                    content,
                    description,
                    path: jumpLink,
                    shareContentType,
                },
                Image: {
                    type,
                    shareContentType,
                    backgroundPicUrl,
                    qrCodeUrl,
                    logoUrl,
                    coachName
                },
                imageBase64: {
                    type,
                    shareContentType,
                    data: this.base64,
                }
            }[shareContentType]
            const data = {
                method: 'share',
                params,
                type: shareContentType
            }
            // 调用app方法
            bindAppFn({
                name: 'app',
                data
            })
        },
        // 保存图片
        save () {
            // 调用app方法
            bindAppFn({
                name: 'app',
                data: {
                    method: 'savePicturesBase64',
                    params: {
                        data: this.base64
                    }
                },
                error: (e) => {
                    this.tips()
                }
            })
        },
    },
    async mounted () {
        this.init()
    }
}
</script>
<style lang="scss">
#canvas-poster {
    position: absolute;
    display: none;
}
</style>